import React, { Component } from "react";
import CreditsTable from "./creditsTable";
import { getCredits } from "../services/creditService";
import Spinner from "./common/spinner";
import AddButton from "./common/addButton";

class Credits extends Component {
  state = {
    credits: [],
    loading: false,
  };

  async componentDidMount() {
    this.setState({ loading: true });
    const result = await getCredits();
    this.setState({ loading: false });
    const { data: credits } = result.data;
    this.setState({ credits });
  }

  getPagedData = () => {
    const { credits } = this.state;

    console.log(credits);
    return { data: credits };
  };

  render() {
    const { data: credits } = this.getPagedData();
    const { loading } = this.state;
    if (loading) return <Spinner message="loading page data..." />;
    return (
      <React.Fragment>
        {/*  <AddButton link="/credits/new" value="Credit Wallet" /> */}
        <CreditsTable credits={credits} message="Credit Transactions" />
      </React.Fragment>
    );
  }
}

export default Credits;
